import { createNavigation } from 'next-intl/navigation'
import { routing } from './routing'
import { ComponentProps } from 'react'

// Lightweight wrappers around Next.js' navigation
// APIs that consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing)

type SlugLinkProps = Omit<
  ComponentProps<typeof Link> & {
    baseHref: string
    slug: string
  },
  'href'
>

export const SlugLink = ({ baseHref, slug, ...rest }: SlugLinkProps) => {
  return <Link href={`${baseHref}/${slug.slice(3)}`} {...rest} />
}
